var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStarsLayer = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 300,
  height: 387,
  viewBox: "0 0 300 387",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  style: {
    verticalAlign: "middle"
  }
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M70.5633 78.999C67.8927 79.0481 65.9603 77.2581 65.2973 74.0709C64.6607 71.0045 63.994 67.9457 63.4478 64.8642C61.1275 51.7981 51.7745 42.682 38.5078 40.3785C35.4868 39.8535 32.4809 39.2342 29.4976 38.5318C26.5821 37.8483 25 35.9904 25 33.5206C25 30.8848 26.7742 28.9739 29.8027 28.3357C33.8445 27.4823 37.9315 26.8063 41.913 25.7338C53.786 22.5315 60.7018 14.5861 63.3423 2.72464C64.1861 -1.06302 64.9018 -4.87711 65.8209 -8.64589C66.2993 -10.6096 67.8437 -11.6292 69.7761 -11.9313C71.7348 -12.2372 73.3734 -11.5121 74.5637 -9.94495C75.2982 -8.98199 75.5016 -7.78489 75.7653 -6.618C76.9104 -1.55772 77.4001 3.68006 79.3889 8.52131C83.4835 18.4871 91.0736 24.2195 101.489 26.4023C104.736 27.082 107.998 27.6824 111.245 28.3508C114.175 28.9551 115.946 30.8545 115.999 33.3847C116.055 35.9262 114.443 37.8521 111.444 38.5394C107.723 39.3928 103.941 39.9744 100.238 40.8996C87.0619 44.1888 79.6903 52.8441 77.2795 66.0198C76.7823 68.7312 76.2437 71.4312 75.6786 74.1275C75.027 77.2506 73.2151 78.9499 70.5633 78.999Z",
  fill: "url(#paint0_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M270.05 229.999C267.937 230.038 266.408 228.622 265.884 226.1C265.38 223.674 264.852 221.254 264.42 218.816C262.584 208.478 255.184 201.265 244.687 199.442C242.297 199.027 239.919 198.537 237.559 197.981C235.252 197.44 234 195.97 234 194.016C234 191.931 235.404 190.419 237.8 189.914C240.998 189.239 244.231 188.704 247.382 187.855C256.776 185.322 262.248 179.035 264.337 169.65C265.004 166.653 265.571 163.636 266.298 160.654C266.676 159.1 267.898 158.293 269.427 158.054C270.977 157.812 272.273 158.386 273.215 159.626C273.796 160.388 273.957 161.335 274.166 162.258C275.072 166.262 275.459 170.406 277.033 174.237C280.273 182.122 286.278 186.657 294.519 188.384C297.088 188.922 299.669 189.397 302.238 189.926C304.556 190.404 305.957 191.907 305.999 193.909C306.044 195.92 304.768 197.443 302.396 197.987C299.451 198.662 296.459 199.123 293.529 199.855C283.104 202.457 277.271 209.305 275.364 219.73C274.971 221.875 274.544 224.012 274.097 226.145C273.582 228.616 272.148 229.96 270.05 229.999Z",
  fill: "url(#paint1_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M246.527 78.9996C245.383 79.0206 244.554 78.2535 244.27 76.8875C243.997 75.5734 243.712 74.2624 243.478 72.9418C242.483 67.342 238.475 63.4352 232.789 62.4479C231.494 62.2229 230.206 61.9575 228.928 61.6565C227.678 61.3636 227 60.5673 227 59.5088C227 58.3792 227.76 57.5603 229.058 57.2867C230.79 56.921 232.542 56.6313 234.248 56.1716C239.337 54.7992 242.301 51.394 243.432 46.3106C243.794 44.6873 244.101 43.0527 244.495 41.4375C244.7 40.5959 245.362 40.1589 246.19 40.0294C247.029 39.8983 247.731 40.2091 248.242 40.8807C248.556 41.2934 248.644 41.8065 248.757 42.3066C249.247 44.4753 249.457 46.72 250.31 48.7948C252.064 53.0659 255.317 55.5227 259.781 56.4581C261.172 56.7494 262.571 57.0068 263.962 57.2932C265.218 57.5522 265.977 58.3662 265.999 59.4506C266.024 60.5398 265.333 61.3652 264.048 61.6597C262.453 62.0255 260.832 62.2747 259.245 62.6713C253.598 64.0809 250.439 67.7903 249.406 73.437C249.192 74.5991 248.962 75.7562 248.719 76.9118C248.44 78.2502 247.664 78.9785 246.527 78.9996Z",
  fill: "url(#paint2_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M47.5216 213C46.6118 213.016 45.9535 212.407 45.7277 211.321C45.5108 210.276 45.2837 209.234 45.0976 208.185C44.3072 203.733 41.121 200.628 36.6016 199.843C35.5724 199.664 34.5484 199.453 33.5321 199.214C32.5389 198.981 32 198.348 32 197.507C32 196.609 32.6044 195.958 33.6361 195.741C35.013 195.45 36.4052 195.22 37.7616 194.854C41.8062 193.763 44.1622 191.057 45.0617 187.016C45.3491 185.726 45.5929 184.426 45.906 183.143C46.069 182.474 46.5951 182.126 47.2534 182.023C47.9206 181.919 48.4788 182.166 48.8843 182.7C49.1346 183.028 49.2038 183.436 49.2937 183.833C49.6838 185.557 49.8506 187.342 50.5281 188.991C51.9229 192.386 54.5086 194.339 58.0566 195.082C59.1627 195.314 60.274 195.518 61.3801 195.746C62.3784 195.952 62.9815 196.599 62.9995 197.461C63.0188 198.326 62.4695 198.983 61.4481 199.217C60.1803 199.507 58.892 199.706 57.6306 200.021C53.142 201.141 50.6308 204.09 49.8095 208.578C49.6401 209.502 49.4566 210.422 49.2642 211.34C49.0422 212.404 48.4249 212.983 47.5216 213Z",
  fill: "url(#paint3_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 6.5,
  cy: 6.5,
  r: 6.5,
  transform: "matrix(1 0 0 -1 19 101)",
  fill: "url(#paint4_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 269.5,
  cy: 37.5,
  r: 3.5,
  fill: "url(#paint5_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 75.5,
  cy: 216.5,
  r: 3.5,
  fill: "url(#paint6_linear_1817_19902)",
  fillOpacity: 0.6
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
  cx: 0,
  cy: 387,
  r: 3.5,
  fill: "url(#paint6_linear_1817_19902)",
  fillOpacity: 0.6
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1817_19902",
  x1: 45.0249,
  y1: 50.9128,
  x2: 120.661,
  y2: 48.4488,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1817_19902",
  x1: 249.844,
  y1: 207.777,
  x2: 309.688,
  y2: 205.828,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1817_19902",
  x1: 235.582,
  y1: 66.9626,
  x2: 267.997,
  y2: 65.9066,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1817_19902",
  x1: 38.8217,
  y1: 203.432,
  x2: 64.5877,
  y2: 202.592,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1817_19902",
  x1: 2.8607,
  y1: 8.98755,
  x2: 13.6658,
  y2: 8.63555,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1817_19902",
  x1: 267.54,
  y1: 38.8394,
  x2: 273.359,
  y2: 38.6499,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1817_19902",
  x1: 73.5404,
  y1: 217.839,
  x2: 79.3585,
  y2: 217.65,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.0190149,
  stopColor: "#FFD5A9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.457575,
  stopColor: "#FFAE5F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FF7182"
})))));
export default SvgStarsLayer;